<div class="menu-indice">Reporte de Constancias Emitidas por Curso</div>
<mdb-card>
    <mdb-card-body>
        <div class="form-row align-items-center">
          <div class="form-group col-md-2">
            Curso de Constancia:
          </div>
          <div class="form-group col-md-4">
                    <select class="browser-default custom-select" [(ngModel)]="cboCurso">
                    <option value="0" selected>Todos</option>
                    <option *ngFor="let lisCurso of listCursos" [value]="lisCurso.x_curso">{{lisCurso.x_curso}}</option>
                    </select>
          </div>
          <div class="form-group col-md-1">
          </div>


          <div class="form-group col-md-2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox"  [(ngModel)]="conrango" id="flexSwitchCheckChecked">
              <label class="form-check-label" for="flexSwitchCheckChecked">Rango de Fechas</label>
            </div>
          </div>

            <div class="form-group col-md-2">
              <button mdbBtn type="button" id="btnBuscar" (click)="onBuscar()" size="md" color="blue" mdbWavesEffect>
              <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
            </div>

        </div>

        <div class="form-row align-items-center" *ngIf="conrango">
          <div class="form-group col-md-2">
            Fecha Inicio:
          </div>
          <div class="form-group col-md-2">
            <input type="date" id="txtFechaIni" maxlength="10" min="2022-01-01" max="2030-12-31" [(ngModel)]="fecha_ini" class="form-control" mdbInput>
          </div>
          <div class="form-group col-md-1">
          </div>
          <div class="form-group col-md-1">
            Fin:
          </div>
          <div class="form-group col-md-2">
            <input type="date" id="txtFechaIni" maxlength="10" min="2022-01-01" max="2030-12-31" [(ngModel)]="fecha_fin" class="form-control" mdbInput>
          </div>
        </div>
    </mdb-card-body>
  </mdb-card>
  <br/>
  <div class="row" *ngIf="listResultado.length>0">
    <div class="col-md-10" style="text-align: left;padding-bottom: 5px;font-weight: 500;font-size: 13px;">Total : {{listResultado.length}}</div>
    <div class="col-md-2" style="text-align: end;"> <a (click)="onExportarExcel()" style="text-align: right;font-weight: 500;font-size: 13px;">Exportar <mdb-icon far icon="file-excel" class="green-text" size="lg" aria-hidden="true"></mdb-icon></a></div>
  </div>
  <mdb-card>
    <div class="table-responsive">
    <table mdbTable hover="true" class="table">
        <thead>
          <tr>
            <th *ngFor="let head of headElements" scope="col">{{head}}</th>
          </tr>
        </thead>
        <tbody>
          <tr mdbTableCol *ngFor="let listRes of listResultado | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
            <th>{{i + 1+ (page-1)*10}}</th>
            <th>{{listRes.f_constancia}}</th>
            <th>{{listRes.x_tipo}}</th>
            <th>{{listRes.x_nro_constancia}}</th>
            <th>{{listRes.x_nombres}}</th>
            <!--
              <th>{{listRes.x_correo}}</th>
             -->

            <th>{{listRes.x_nota}}</th>
            <td>{{listRes.x_envio_correo}}</td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="text-center">

      <ngb-pagination [maxSize]=3 [(page)]="page" class="d-flex justify-content-center"
        [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listResultado.length">
      </ngb-pagination>

    </div>
  </mdb-card>

  <br>
